var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonSignUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a22d531a-1db3-43e2-859a-4a261580f2f9",
    "data-name": "e79e5009-f742-4171-911c-c8749badb31a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 177 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a5aa551d-e9a5-477f-b2c4-8637eec2d206{fill:#0fc571;}.ec1f84f4-2c67-4929-8784-ae4e679c97f0{isolation:isolate;font-size:19px;fill:#fff;font-family:Rubik-Medium, Rubik;font-weight:500;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bc95e025-b479-4b77-b4cf-ff9af367d30c",
    "data-name": "f69de091-b1ce-47bb-9992-d4bf9d184b8d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f3061ec6-9813-463a-9c30-ba775c6ca6d5",
    "data-name": "b0681089-dbf9-4cf7-8e68-c690df5db330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b2222267-3520-41a6-b053-8fa4c3866635",
    "data-name": "aaa35b11-d76a-420d-a437-007d7bff1e9e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "adc44581-3c22-473e-861d-28a3eb745a8d",
    "data-name": "a53208f9-bf2e-4e9e-8e4a-415a6268d806"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a5aa551d-e9a5-477f-b2c4-8637eec2d206",
    d: "M133,0H5A5,5,0,0,0,0,5L10,41a5,5,0,0,0,5,5H133a5,5,0,0,0,5-5V5A5,5,0,0,0,133,0Z"
  }))), /*#__PURE__*/React.createElement("text", {
    className: "ec1f84f4-2c67-4929-8784-ae4e679c97f0",
    transform: "translate(32 30)"
  }, "SIGN UP")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonSignUp);
export default __webpack_public_path__ + "static/media/button-sign-up.d52ebedf39efdd0a6bf09bf9a90b8b06.svg";
export { ForwardRef as ReactComponent };